import { SystemEntity } from '@erp/shared-types';
import { Badge } from '@/components/ui/badge';
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from '@/components/ui/hover-card';
import { cn } from '@/lib/utils';
import { FileTextIcon } from '@phosphor-icons/react';
import { SystemEntityPreview } from '../preview-ui';
import { useArInvoice } from '@/api/rpc/hooks/accounts-receivable/useArInvoices';

interface ARInvoiceInlineProps {
  entityType: SystemEntity; // required by registry; type is AR_INVOICE
  entityId: string;
  className?: string;
}

export function ARInvoiceInline({ entityId, className }: ARInvoiceInlineProps) {
  const { invoice, isLoading } = useArInvoice(entityId);

  const displayName = isLoading
    ? 'Loading...'
    : invoice?.invoiceNumber
      ? `Invoice ${invoice.invoiceNumber}`
      : 'Invoice';

  return (
    <HoverCard openDelay={200} closeDelay={100}>
      <HoverCardTrigger asChild>
        <div className="inline-block max-w-full">
          <Badge
            variant="outline"
            className={cn('gap-1.5 cursor-pointer max-w-full', className)}
          >
            <FileTextIcon className="size-3 shrink-0" />
            <span className="truncate">{displayName}</span>
          </Badge>
        </div>
      </HoverCardTrigger>
      <HoverCardContent
        className="w-auto p-0 pointer-events-auto"
        align="start"
        side="bottom"
        sideOffset={2}
        onPointerEnter={(e) => e.stopPropagation()}
        onPointerLeave={(e) => e.stopPropagation()}
      >
        <SystemEntityPreview
          entityType={SystemEntity.AR_INVOICE}
          entityId={entityId}
        />
      </HoverCardContent>
    </HoverCard>
  );
}
